<!--
    Summary:
        hkml.exhibition.web - Y-ChromosomeDNATest
    ChangeLog:
        wangn on 2020/11/16 added
-->
<template>
  <div class="v-y-dna-test" title="YDNATest">
    <sub-banner>
      <img src="../../../assets/images/projects/y-dna-test/p1.jpg"/>
      <div slot="title">
        {{$t('YDnaTest.p1_title')}}
      </div>
      <a href="/" slot="action">{{$t('YDnaTest.p1_action')}}</a>
    </sub-banner>

    <p2-xy v-if="!isEng"></p2-xy>
    <p2-xy-en v-else></p2-xy-en>
    <p3-y-dna-test3 v-if="!isEng"></p3-y-dna-test3>
    <p3-y-dna-test3-en v-else></p3-y-dna-test3-en>
    <p4-y-dna-test4 v-if="!isEng"></p4-y-dna-test4>
    <p4-y-dna-test4-en v-else></p4-y-dna-test4-en>
    <p5-strategy></p5-strategy>
    <p6-advantages></p6-advantages>
    <p7-procedures></p7-procedures>
    <p8-attention></p8-attention>
    <p6-report></p6-report>
  </div>
</template>

<script>
  import SubBanner from "@/components/sub-banner";
  import P2Xy from "./p2-xy";
  import P3YDnaTest3 from "./p3-y-dna-test3";
  import P4YDnaTest4 from "./p4-y-dna-test4";
  import P5Strategy from "./p5-strategy";
  import P6Advantages from "./p6-advantages";
  import P7Procedures from "./p7-procedures";
  import P8Attention from "./p8-attention";
  import P6Report from "../../home/p6-report";
  import P2XyEn from "./p2-xy-en";
  import P3YDnaTest3En from "./p3-y-dna-test3-en";
  import P4YDnaTest4En from "./p4-y-dna-test4-en";

  export default {
    name: "v-y-dna-test",
    components: {P4YDnaTest4En, P3YDnaTest3En, P2XyEn, P6Report, P8Attention, P7Procedures, P6Advantages, P5Strategy, P4YDnaTest4, P3YDnaTest3, P2Xy, SubBanner},
    computed: {
      isEng: function () {
        return this.$i18n.locale === 'en-US';
      }
    },
  }
</script>

<style lang="scss">
  .v-y-dna-test {
    color: #000000;
  }
</style>




// WEBPACK FOOTER //
// src/view/projects/y-dna-test/y-dna-test.vue